import riot from 'riot';

riot.tag(
    'form-mixin-info',
    '<i class="msc-icon icon-info-circular-outline protip" data-pt-title="{ opts.text }" data-pt-classes="{ opts.class }"></i>',
    function () {},
);
